export enum CaseNavigationType {
  Open = "open",
  Resolved = "resolved",
  Archived = "archived",
}
